<template>
  <div>
    <el-row :gutter="16">
      <el-col :span="12"
              style="animation-duration: 500ms"
              :class="{ animate__animated: true, animate__slideInLeft: isIn, animate__slideOutLeft: isOut }">
        <el-row :gutter="16">
          <el-col :span="16">
            <div class="middle_container"
                 style="margin-bottom:16px">
              <span class="title">故障总览</span>
              <el-row style="margin-top:32px;padding-left:16px;padding-right:16px">
                <el-col :span="12">
                  <el-col :span="24"
                          style="text-align:center;font-weight:bold;color:#ff4500;font-size:20px;padding-top:16px">
                    <span>当前故障</span>
                    <br><span style="font-size:14px;">{{outlineData.nofinishFaults==null?0:outlineData.nofinishFaults.length}}</span>
                  </el-col>
                  <el-col :span="12"
                          style="text-align:center;font-weight:bold;color:#ff4500;font-size:16px;padding-top:24px">
                    <span>当日发生</span>
                    <br><span style="font-size:14px;">{{outlineData.todayOccuCount}}</span>
                  </el-col>
                  <el-col :span="12"
                          style="text-align:center;font-weight:bold;color:#59f2ff;font-size:16px;padding-top:24px">
                    <span>当日处理</span>
                    <br><span style="font-size:14px;color:#ddd">{{outlineData.todaySolveCount}}</span>
                  </el-col>
                  <el-col :span="12"
                          style="text-align:center;font-weight:bold;color:#ff4500;font-size:16px;padding-top:24px">
                    <span>当月发生</span>
                    <br><span style="font-size:14px;">{{outlineData.thisMonthOccuCount}}</span>
                  </el-col>
                  <el-col :span="12"
                          style="text-align:center;font-weight:bold;color:#59f2ff;font-size:16px;padding-top:24px">
                    <span>当月处理</span>
                    <br><span style="font-size:14px;color:#ddd">{{outlineData.thisMonthSolveCount}}</span>
                  </el-col>
                </el-col>
                <el-col :span="2"
                        style="text-align: center;">
                  <img src="../../assets/imgs/dashboard/separator2x315.png"
                       style="height:240px" />
                </el-col>
                <el-col :span="10">
                  <el-row class="content"
                          style="margin-bottom:12px;margin-top:20px;">
                    <el-col style="text-align:center">
                      <div class="esh1">提交专工故障数</div>
                      <div class="esh2"
                           style="color:#ddd">
                        {{outlineData.profFaultCount}}
                      </div>
                    </el-col>
                  </el-row>
                  <el-row class="content"
                          style="margin-bottom:12px;margin-top:20px;">
                    <el-col style="text-align:center">
                      <div class="esh1"
                           style="color:#ff4500">被激活故障数</div>
                      <div class="esh2"
                           style="color:#ff4500">
                        {{outlineData.activeFaultCount}}
                      </div>
                    </el-col>
                  </el-row>
                  <el-row class="content"
                          style="margin-bottom:12px;margin-top:20px;">
                    <el-col style="text-align:center">
                      <div class="esh1">故障处理平均时长</div>
                      <div class="esh2"
                           style="color:#ddd">
                        {{outlineData.avgTime>=60?(outlineData.avgTime/60).toFixed(2)+'小时':outlineData.avgTime+'分钟'}}
                      </div>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="small_container"
                 style="margin-bottom:16px">
              <span class="title">故障解决率</span>
              <div style="margin-top:50px;padding-left:16px;padding-right:16px">
                <div id="done_rate_panel"
                     style="width:100%;height:230px;"></div>
              </div>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="16">
            <div class="middle_container"
                 style="margin-bottom:16px;">
              <span class="title">处理时长TOP10</span>
              <div style="width:calc(100% - 10px);height:240px;margin-top:30px;margin-left:10px"
                   id="top10panel"></div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="small_container"
                 style="margin-bottom:16px">
              <span class="title">故障等级分布</span>
              <div style="margin-top:35px;padding-left:16px;padding-right:16px">
                <div id="level_dis_panel"
                     style="width:100%;height:250px"></div>
              </div>
            </div>
          </el-col>
        </el-row>

        <el-row :gutter="16">
          <el-col :span="8">
            <div class="small_container"
                 style="margin-bottom:16px">
              <span class="title">故障系统分布</span>
              <div style="margin-top:35px;padding-left:16px;padding-right:16px">
                <div id="sys_dis_panel"
                     style="width:100%;height:250px"></div>
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="small_container"
                 style="margin-bottom:16px;cursor: pointer;">
              <span class="title">故障组织分布</span>
              <div style="margin-top:35px;padding-left:16px;padding-right:16px">
                <div id="org_dis_panel"
                     style="width:100%;height:250px"></div>
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="small_container"
                 style="margin-bottom:16px;cursor: pointer;">
              <span class="title">设备类型分布</span>
              <div style="margin-top:35px;padding-left:16px;padding-right:16px">
                <div id="assettype_dis_panel"
                     style="width:100%;margin-top:35px;height:250px"></div>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="12"
              style="animation-duration: 500ms"
              :class="{ animate__animated: true, animate__slideInRight: isIn, animate__slideOutRight: isOut }">
        <el-row>
          <el-col>
            <div class="fat_container">
              <span class="title">实时故障信息</span>
              <el-carousel height="580px"
                           style="margin-top:36px;"
                           direction="vertical"
                           :interval="5000">
                <el-carousel-item v-for="item in nofinishFaults"
                                  :key="item.id">
                  <div class="c_alarm_panel"
                       style="cursor: pointer;"
                       v-for="ele in item"
                       :key="ele.id"
                       @click="go_fault_detail(ele.id,ele.code)">
                    <table style="width:100%;">
                      <tr>
                        <td rowspan="2"
                            width="110px">
                          <div class="alarm_1">{{ele.level_name}}</div>
                        </td>
                        <td align="left"
                            style="color:#ddd;font-size:16px;padding-top:10px"><span style="cursor: pointer;">{{ ele.org_name+'>'+ele.area_name+'>'+ele.equi_name }}</span>
                          <el-tag size="mini"
                                  type="danger"
                                  effect="dark"
                                  style="margin-left:4px"
                                  v-if="ele.process!=null&&ele.process.startsWith('挂起')">挂起</el-tag>
                        </td>
                        <td align="right"
                            style="color:#ddd;font-size:14px;padding-right:8px;padding-top:10px">上报时间：{{ ele.occu_time.replace('T',' ').substring(0,16) }}</td>
                      </tr>
                      <tr>
                        <td align="left"><span style="cursor: pointer;">{{ '【'+ele.code+'】'+ele.appe_name+(ele.des==null?'':('：'+ele.des)) }}</span></td>
                        <td align="right"
                            style="font-size:14px;padding-right:8px">上报人：{{ ele.reporte_name }}</td>
                      </tr>
                    </table>
                  </div>
                </el-carousel-item>
              </el-carousel>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <div class="big_container"
                 style="cursor: pointer;">
              <span class="title">近30日故障曲线</span>
              <el-row>
                <div id="days_alarm_panel"
                     style="width:100%;height:300px;margin-left:12px;margin-right:12px;"></div>
              </el-row>
            </div>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <div style="animation-duration: 500ms;"
         class="model_panel"
         v-if="viewFaultVisible"
         :class="{ frame:true,animate__animated: true, animate__bounceInDown: contentIsIn, animate__bounceOutUp: contentIsOut}">
      <div class="model_large"
           style="color: #59f2ff;">
        <el-button icon="el-icon-close"
                   class="close"
                   circle
                   type="danger"
                   size="large"
                   @click="colseFaultDetail"></el-button>
        <div class="model-title">{{faultInfo.code}}</div>
        <div class="model-content">
          <el-row>
            <el-col :span="8"
                    style="margin-bottom:12px">
              组织：{{faultInfo.orgName}}
            </el-col>
            <el-col :span="8"
                    style="margin-bottom:12px">
              区域：{{faultInfo.areaName}}
            </el-col>
            <el-col :span="8"
                    style="margin-bottom:12px">
              设备：{{faultInfo.equiName}}
            </el-col>
            <el-col :span="8"
                    style="margin-bottom:12px">
              设备类型：{{faultInfo.equiTypeName}}
            </el-col>
            <el-col :span="8"
                    style="margin-bottom:12px">
              设备型号：{{faultInfo.equiModelName}}
            </el-col>
            <el-col :span="8"
                    style="margin-bottom:12px">
              所属系统：{{faultInfo.systemName}}
            </el-col>
            <el-col :span="8"
                    style="margin-bottom:12px">
              故障现象：{{faultInfo.appeName}}
            </el-col>
            <el-col v-if="faultInfo.des!=null&&faultInfo.des!=''"
                    :span="8"
                    style="margin-bottom:12px">
              故障描述：{{faultInfo.des}}
            </el-col>
            <el-col :span="8"
                    style="margin-bottom:12px">
              故障等级：{{faultInfo.levelName}}
            </el-col>
            <el-col :span="8"
                    style="margin-bottom:12px">
              上报时间：{{faultInfo.occuTime}}
            </el-col>
            <el-col :span="8"
                    style="margin-bottom:12px">
              上报人：{{faultInfo.reporteName}}
            </el-col>
            <el-col :span="8"
                    style="margin-bottom:12px">
              故障状态：{{stateFormat(faultInfo.state)}}
            </el-col>
            <el-col :span="8"
                    v-if="faultInfo.state==2"
                    style="margin-bottom:12px">
              责任人：{{faultInfo.resolverName}}
            </el-col>
            <el-col :span="8"
                    style="margin-bottom:12px">
              是否提交专工：{{faultInfo.isProf==0?'否':'是'}}
            </el-col>
            <el-col :span="8"
                    style="margin-bottom:12px">
              是否曾经激活：{{faultInfo.isActived==0?'否':'是'}}
            </el-col>
            <!-- 扩展字段 -->
            <el-col v-for="item in extendDataReport"
                    :key="item.id"
                    :span="8"
                    style="margin-bottom:12px">
              {{item.label}}：{{item.value}}
            </el-col>
          </el-row>
          <es-img :info="faultInfo"
                  :fileList="fileListView"
                  type="view"></es-img>
          <template v-if="faultInfo.state==3">
            <el-divider><span style="color:#409eff">解决信息</span></el-divider>
            <el-row>
              <el-col :span="8"
                      style="margin-bottom:12px">
                解决方案：{{faultInfo.solutionName}}
              </el-col>
              <el-col :span="8"
                      style="margin-bottom:12px">
                方案描述：{{faultInfo.solutionDes}}
              </el-col>
              <el-col v-if="faultInfo.measures!=null&&faultInfo.measures!=''"
                      :span="8"
                      style="margin-bottom:12px">
                解决措施：{{faultInfo.measures}}
              </el-col>
              <el-col :span="8"
                      style="margin-bottom:12px">
                解决人：{{faultInfo.resolverName}}
              </el-col>
              <el-col :span="8"
                      style="margin-bottom:12px">
                解决时间：{{faultInfo.solveTime}}
              </el-col>
              <el-col v-if="faultInfo.companionName!=null&&faultInfo.companionName!=''"
                      :span="8"
                      style="margin-bottom:12px">
                协作人员：{{faultInfo.companionName}}
              </el-col>
              <!-- 扩展字段 -->
              <el-col v-for="item in extendDataSolve"
                      :key="item.id"
                      :span="8"
                      style="margin-bottom:12px">
                {{item.label}}：{{item.value}}
              </el-col>
            </el-row>
            <es-img :info="faultInfo"
                    :fileList="fileListView2"
                    type="view"></es-img>
          </template>
          <template v-if="matConsume!=null&&matConsume.length>0">
            <el-divider><span style="color:#409eff">材料信息</span></el-divider>
            <table style="width:100%;">
              <tr>
                <td><b>材料类型</b></td>
                <td><b>材料型号</b></td>
                <td><b>数量</b></td>
                <td><b>单位</b></td>
                <td><b>材料编码</b></td>
              </tr>
              <tr v-for="item in matConsume"
                  :key="item.id">
                <td>{{item.matTypeName}}</td>
                <td>{{item.matModelName}}</td>
                <td>{{item.quantity}}</td>
                <td>{{item.unit}}</td>
                <td>{{item.matNumber}}</td>
              </tr>
            </table>
          </template>
          <el-divider><span style="color:#409eff">过程信息</span></el-divider>
          <table style="width:100%;">
            <tr>
              <td><b>操作人</b></td>
              <td><b>动作</b></td>
              <td><b>被操作人</b></td>
              <td><b>时间</b></td>
            </tr>
            <tr v-for="item in activities"
                :key="item.id">
              <td>{{item.senderName}}</td>
              <td>{{item.des}}</td>
              <td>{{item.receiverName}}</td>
              <td>{{item.createTime}}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'dashboardfault',
  props: {},
  data () {
    return {
      isIn: true,
      isOut: false,
      outlineData: {},
      nofinishFaults: [],
      contentIsIn: true,
      contentIsOut: false,
      viewFaultVisible: false,
      faultInfo: {},
      fileListView: [],
      fileListView2: [],
      extendDataReport: {},
      extendDataSolve: {},
      activities: [],
      matConsume: []

    }
  },

  methods: {
    init () {
      this.loadOutlineData()
      this.loadDaysFaults()
    },
    loadOutlineData () {
      this.$ajax.get('/buss/dashboard/get_fau_outlinedata').then((msg) => {
        this.outlineData = msg

        let tempfaus = []
        let tempfaus1 = []
        let i = 0
        let j = 0
        for (let n = 0; n < msg.nofinishFaults.length; n++) {
          tempfaus1[j] = msg.nofinishFaults[n]
          j++
          if (j == 7) {
            tempfaus[i] = JSON.parse(JSON.stringify(tempfaus1))
            i++
            j = 0
            tempfaus1 = []
          }
        }
        if (j > 0) {
          tempfaus[i] = tempfaus1
        }
        this.nofinishFaults = tempfaus

        //故障解决率
        let alarmchart = this.$echarts.init(document.getElementById('done_rate_panel'))
        let alarmoption = {
          series: [
            {
              type: 'gauge',
              radius: '100%',
              detail: {
                formatter: '{value}%',
                fontSize: 14,
                color: '#ddd'
              },
              data: [
                {
                  title: {
                    show: true,
                    fontSize: 16,
                    offsetCenter: [0, 80],
                    color: '#ddd'
                  },
                  value: msg.todayOccuCount == 0 ? 100 : (msg.todaySolveCount * 100 / msg.todayOccuCount).toFixed(2),
                  name: '当日解决率'
                }
              ],
              axisLine:
              {
                lineStyle: {
                  color: [[0.2, '#c23531'], [0.8, '#409eff'], [1, 'green']]
                }
              }
            }
          ]
        }
        alarmchart.setOption(alarmoption);
        //用时top10
        this.initTimeTop10(msg.timeTop10)

        //故障等级分布
        let levelchart = this.$echarts.init(document.getElementById('level_dis_panel'))
        let leveloption = {
          tooltip: {
            trigger: 'item'
          },
          color: ['#ffa500', '#ff4500', '#8b0000', '#409eff', '#c23531'],
          series: [
            {
              name: '等级分布',
              type: 'pie',
              left: 0,
              radius: ['50%', '80%'],
              label: {
                show: true,
                position: 'center',
                formatter: '故障等级分布',
                fontSize: 16
              },
              labelLine: {
                show: false
              },
              data: msg.levelDis
            }
          ]
        }
        levelchart.setOption(leveloption);

        //故障系统分布
        levelchart = this.$echarts.init(document.getElementById('sys_dis_panel'))
        leveloption = {
          tooltip: {
            trigger: 'item'
          },
          color: ['#ffa500', '#ff4500', '#8b0000', '#409eff', '#c23531'],
          series: [
            {
              name: '系统分布',
              type: 'pie',
              left: 0,
              radius: ['50%', '80%'],
              label: {
                show: true,
                position: 'center',
                formatter: '故障系统分布',
                fontSize: 16
              },
              labelLine: {
                show: false
              },
              data: msg.sysDis
            }
          ]
        }
        levelchart.setOption(leveloption)

        //故障组织分布
        levelchart = this.$echarts.init(document.getElementById('org_dis_panel'))
        leveloption = {
          tooltip: {
            trigger: 'item'
          },
          color: ['#ffa500', '#ff4500', '#8b0000', '#409eff', '#c23531'],
          series: [
            {
              name: '组织分布',
              type: 'pie',
              left: 0,
              radius: ['50%', '80%'],
              label: {
                show: true,
                position: 'center',
                formatter: '故障组织分布',
                fontSize: 16
              },
              labelLine: {
                show: false
              },
              data: msg.orgDis
            }
          ]
        }
        levelchart.setOption(leveloption)

        //设备类型分布
        levelchart = this.$echarts.init(document.getElementById('assettype_dis_panel'))
        leveloption = {
          tooltip: {
            trigger: 'item'
          },
          color: ['#ffa500', '#ff4500', '#8b0000', '#409eff', '#c23531'],
          series: [
            {
              name: '设备类型分布',
              type: 'pie',
              left: 0,
              radius: ['50%', '80%'],
              label: {
                show: true,
                position: 'center',
                formatter: '设备类型分布',
                fontSize: 16
              },
              labelLine: {
                show: false
              },
              data: msg.assetTypeDis
            }
          ]
        }
        levelchart.setOption(leveloption)

      }).catch(err => {
        this.$message.error(err)
      })

    },
    loadDaysFaults () {
      this.$ajax.get('/buss/dashboard/get_daysFaults').then((msg) => {
        let names = []
        let values = []
        msg.forEach(e => {
          names.push(e.name)
          values.push(e.value)
        })
        //近三十天故障曲线
        let daysalarmchart = this.$echarts.init(document.getElementById('days_alarm_panel'))
        let daysalarmoption = {
          xAxis: {
            type: 'category',
            data: names,
            axisLine: {
              lineStyle: {
                color: '#ddd'
              }
            }
          },
          yAxis: {
            type: 'value',
            axisLine: {
              lineStyle: {
                color: '#ddd'
              }
            }
          },
          tooltip: {
            trigger: 'item',
            formatter: '<b>{b}</b><br/>{c}个'
          },
          series: [
            {
              data: values,
              type: 'line',
              smooth: true,

            }
          ]
        }
        daysalarmchart.setOption(daysalarmoption)

      }).catch(err => {
        this.$message.error(err)
      })
    },

    initTimeTop10 (msg) {
      let data = []
      let label = []
      msg.forEach(e => {
        data.unshift(e.num)
        label.unshift(e.name)
      })
      var top10panel = document.getElementById('top10panel');
      var myChart = this.$echarts.init(top10panel);
      let option = {
        tooltip: { trigger: 'item' },
        grid: {
          top: 15,
          bottom: 20,
          left: 130
        },
        xAxis: {
          axisLine: {
            lineStyle: {
              color: '#ddd'
            }
          }
        },
        yAxis: {
          data: label,
          axisLine: {
            lineStyle: {
              color: '#ddd'
            }
          },
          triggerEvent: true
        },
        series: [
          {
            data: data,
            type: 'bar',
            barWidth: '50%',
            tooltip: {
              formatter: '{b}：{c}分钟'
            },
            itemStyle: {
              normal: {
                color: function (params) {
                  let colorList = ['#6BF1BF', '#C7F895', '#E6D349', '#F8A065', '#FFA500', '#FFA500', '#FF4500', '#FF4500', '#8B0000', '#8B0000']
                  return colorList[params.dataIndex]
                }
              }
            }
          }
        ]
      }
      myChart.setOption(option)

      let _this = this
      myChart.on('click', function (params) {
        if (params.componentType == "yAxis") {
          msg.forEach(e => {
            if (params.value == e.name) {
              _this.go_fault_detail(e.id, e.name)
            }
          })
        }
      });
    },
    go_fault_detail (id, code) {
      this.contentIsIn = true
      this.contentIsOut = false
      this.viewFaultVisible = true

      this.$set(this.faultInfo, 'code', code)

      this.fileListView = []
      this.fileListView2 = []
      this.$ajax.get('/buss/fault/load_detail', { id: id }).then((msg) => {
        //初始化图片
        if (msg.attachImgs != null && msg.attachImgs != '') {
          let temp = JSON.parse(msg.attachImgs)
          temp.forEach(e => {
            this.fileListView.push(this.$api + e.url + '&platform=web&token=' + this.$store.getUser().token)
          })
        }
        if (msg.handleImgs != null && msg.handleImgs != '') {
          let temp = JSON.parse(msg.handleImgs)
          temp.forEach(e => {
            this.fileListView2.push(this.$api + e.url + '&platform=web&token=' + this.$store.getUser().token)
          })
        }
        this.faultInfo = msg

        //加载上报扩展属性
        this.$ajax.get('/buss/fault/extend_data', {
          fauId: id, typeId: 1
        }).then((msg1) => {
          this.extendDataReport = msg1
        }).catch(err => {
          this.$message.error(err)
        })
        //加载解決扩展属性
        this.$ajax.get('/buss/fault/extend_data', {
          fauId: this.faultInfo.id, typeId: 2
        }).then((msg2) => {
          this.extendDataSolve = msg2
        }).catch(err => {
          this.$message.error(err)
        })
        //过程信息
        this.$ajax.get('/buss/fault/list_fau_process', { fauId: id }).then((msg3) => {
          this.activities = msg3
        }).catch(err => {
          this.$message.error(err)
        })
        //材料信息
        this.$ajax.get('/buss/fault/list_mat_consume', { fauId: id }).then((msg4) => {
          this.matConsume = msg4
        }).catch(err => {
          this.$message.error(err)
        })
      }).catch(err => {
        this.$message.error(err)
      })
    },
    colseFaultDetail () {
      this.contentIsIn = false
      this.contentIsOut = true
      setTimeout(() => {
        this.viewFaultVisible = false
      }, 500)
    },
    stateFormat (state) {
      if (state == 1) {
        return "待分配"
      } else if (state == 2) {
        return "待解决"
      } else {
        return "已解决"
      }
    },
  },
  mounted () {
    setTimeout(() => {
      this.init()
    }, 500)

    this.clearTimeSet = setInterval(() => {
      this.init()
    }, 30000)
  },

  beforeDestroy () {    //页面关闭时清除定时器  
    clearInterval(this.clearTimeSet);
  },

}
</script>

<style scoped>
.card_container {
  color: #59f2ff;
  font-size: 14px;
  border: 1px solid #00aeff;
  border-radius: 5px;
  box-shadow: 0 0 15px #00aeff inset;
  background-color: transparent;
  width: 100%;
  height: 100px;
  margin-top: 8px;
}
.label {
  color: #dddddd;
  font-size: 16px;
  margin: 0px;
  margin-bottom: 8px;
}
.content {
  color: #59f2ff;
  font-size: 14px;
}
.esh1 {
  font-size: 16px;
  /* font-weight: 700; */
  margin-bottom: 5px;
}
.esh2 {
  font-size: 14px;
  /* font-weight: 700; */
  margin-bottom: 5px;
}
tr {
  height: 30px;
}

.title {
  position: relative;
  color: #59f2ff;
  font-size: 14px;
  top: 18px;
  left: 32px;
}
.c_alarm_panel {
  background-color: #003548;
  width: 100%;
  height: 70px;
  color: #59f2ff;
  text-align: center;
  font-size: 14px;
  margin-bottom: 12px;
  margin-left: 18px;
  width: calc(100% - 36px);
}
.alarm_1 {
  border: 2px solid #ffa500;
  font-weight: 700;
  padding: 4px 8px 4px 8px;
  color: #ffa500;
  font-size: 12px;
  transform: rotate(-20deg);
  margin-left: 10px;
  margin-top: 12px;
  width: 60px;
}
.model-title {
  text-align: center;
  font-size: 18px;
  font-weight: bolder;
  position: relative;
  top: 10px;
  color: #ddd;
}
.model-content {
  color: #ddd;
  font-size: 14px;
  margin: 60px 80px 0px 80px;
  height: 520px;
  overflow-y: auto;
}

.model_panel {
  position: absolute;
  z-index: 1001;
  left: 0;
  top: 0;
  width: 100%;
  height: 1080px;
  background: rgba(0, 0, 0, 0.2);
}
.model_large {
  width: 1200px;
  height: 658px;
  background: url(../../assets/imgs/dashboard/model1200x658.png) no-repeat;
  position: absolute;
  top: 200px;
  left: calc(50% - 600px);
}

.model_large .close {
  left: calc(50% + 600px);
  position: absolute;
  top: -20px;
}
</style>
